import React, {useEffect, useState} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import CardMobileSection from 'components/sales/tableSection/cardMobileSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import {Button} from 'react-bootstrap';

const ContractListing = ({
                             getContractList,
                             contractList,
                             siteFilters,
                             getLocationChange,
                         }) => {
    const [cardListData, setCardListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        (async () => {
            delete window.localStorage.assets_mapping
            setIsLoading(true)
            await getContractList(filterData, 1)
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Site Number',
        'Infra Id',
        'Site Type',
        'Client Name',
        'No.of Gates',
        'Area Name',
        'Assigned To',
        'BA Name',
        'Assigned To Maintenance',
        'Onboard Date',
        'Inst. Start Date',
        'Handover Date',
        'Validate Location',
        'Status',
        'Actions',
    ];
    const cardHeaders = [
        'Site Number',
        'Infra Id',
        'Site Type',
        'Client Name',
        'Area Name',
        'BA Name',
        'Onboard Date',
        'Inst. Start Date',
        'Handover Date',
        'Validate Location',
        'Status',
        'Actions',
    ];

    useEffect(() => {

        const tableData = [
            'site_id',
            'site_no',
            'infra_project_id',
            'lead_id',
            'site_type',
            'client_name',
            'gates',
            'area_name',
            'assigned_to',
            'ba_name',
            'assigned_to_maintenance',
            'created_at',
            'installation_start_date',
            'handover_date',
            'is_location_validate',
            'status',
            'comm_id'
        ];

        if (contractList && contractList?.resultSets) {
            const cardData = contractList.resultSets.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    {
                        Action:
                            [
                                {
                                    name: 'Gate Mapping',
                                    link: `/dashboard/contract-gate/${element['lead_id']}/${element['comm_id']}`
                                },
                            ]
                    }
                )
            );
            if (cardData) {
                const newCardData = cardData.map(function (obj) {
                    delete obj['lead_id'];
                    obj['id'] = obj['site_id']
                    delete obj['site_id'];
                    delete obj['comm_id'];
                    return obj;
                });
                newCardData && setCardListData(newCardData);
            }
            setPageCount(Math.ceil(contractList.total / contractList.per_page));
        }
    }, [contractList]);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        localStorage.setItem("assets_mapping", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await getContractList(filterData, 1);
        setIsLoading(false);
        filterToggle();
    };

    const headerBtns = () => {
        return (
            <>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
                >
                    <img src={Images?.Filter} alt=""/>
                    <b className="site_filters" style={{width: "max-content"}}>
                        {localization.showFilters}
                    </b>
                </Button>
            </>
        );
    };

    const onPageChange = async (val) => {
        let filter = JSON.parse(localStorage.getItem("assets_mapping") && localStorage.getItem("assets_mapping"));
        setIsLoading(true);
        await getContractList(filter, val.selected + 1);
        setIsLoading(false);
    };

    const updateLocation = (val) => {
        const isLocation = val.check === false ? 0 : 1;
        getLocationChange(val.id, isLocation);
    };

    return (
        <Layout
            title={localization.contractListing}
            isLoading={isLoading}
            Buttons={headerBtns}
        >
            {window.screen.width < 1000 ?
                <CardMobileSection
                    data={cardListData}
                    isId={false}
                    isMngId={false}
                    headers={cardHeaders}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    onChange={(val) => {
                        updateLocation(val);
                    }}
                    detailList={contractList && contractList.resultSets}
                    srNo={getContractList?.from}
                />
                :
                <TableSection
                    data={cardListData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    onChange={(val) => {
                        updateLocation(val);
                    }}
                    detailList={contractList && contractList.resultSets}
                    srNo={contractList?.from}
                />
            }
            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                statusId={'1,2,3'}
                listFilterData={siteFilters?.site_types ? siteFilters : null}
                siteFilters
            />
        </Layout>
    );
};

export default ContractListing;
